import { render, staticRenderFns } from "./EstudiantePage.vue?vue&type=template&id=fe88ce12"
import script from "./EstudiantePage.js?vue&type=script&lang=js&external"
export * from "./EstudiantePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports